// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsUbuntuInstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-ubuntu-instances_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={28} x={6} y={6} viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M28 14a14 14 0 1 1-28 0 14 14 0 0 1 28 0M4.48 12.13a1.87 1.87 0 1 0 0 3.74 1.87 1.87 0 0 0 0-3.74m13.35 8.5a1.87 1.87 0 1 0 1.86 3.23 1.87 1.87 0 0 0-1.86-3.23M8.54 14c0-1.85.92-3.48 2.32-4.47L9.5 7.24a8 8 0 0 0-3.36 4.72 2.62 2.62 0 0 1 0 4.08 8 8 0 0 0 3.36 4.72l1.36-2.3A5.5 5.5 0 0 1 8.54 14M14 8.54c2.85 0 5.2 2.19 5.44 4.98l2.66-.04A8 8 0 0 0 19.7 8.2a2.62 2.62 0 0 1-3.52-2.03 8 8 0 0 0-5.77.54l1.3 2.33q1.06-.5 2.3-.51m0 10.92q-1.24-.01-2.3-.5l-1.3 2.32a8 8 0 0 0 5.77.54 2.62 2.62 0 0 1 3.52-2.03 8 8 0 0 0 2.41-5.27l-2.66-.04A5.46 5.46 0 0 1 14 19.46m3.83-12.09a1.87 1.87 0 1 0 1.86-3.23 1.87 1.87 0 0 0-1.86 3.23"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-ubuntu-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsUbuntuInstances",
);
export default AwsUbuntuInstancesIcon;
